module.exports = __webpack_public_path__ + "fonts/f737d53f-f6ed-4f15-8fe7-925fb68a8851.7d7f31d.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/f737d53f-f6ed-4f15-8fe7-925fb68a8851.eot
// module id = 87
// module chunks = 245 246